import { render, staticRenderFns } from "./bindForm.vue?vue&type=template&id=2c8baf6c"
import script from "./bindForm.vue?vue&type=script&lang=js"
export * from "./bindForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports